import { render, staticRenderFns } from "./NominateMemberCreate.vue?vue&type=template&id=7bf0f325"
import script from "./NominateMemberCreate.vue?vue&type=script&lang=js"
export * from "./NominateMemberCreate.vue?vue&type=script&lang=js"
import style0 from "./NominateMemberCreate.vue?vue&type=style&index=0&id=7bf0f325&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports